<template>
  <div class="flex flex-col h-full">
    <div class="content">
      <template v-if="!appPending">
        <p class="font-normal" v-if="results.length">Search results for <span class="text-black font-bold">{{ query }}</span></p>
        <p class="font-normal" v-else>No results for <span class="text-black font-bold">{{ query }}</span></p>
      </template>
      <div class="profiles flex flex-wrap">
        <template v-if="results.length">
          <div class="col-md-4 col-xl-3 my-3" v-for="article in results" v-bind:key="article.id">
            <player-profile-link :article="article"></player-profile-link>
          </div>
        </template>
      </div>
      <div v-if="results.length" class="pagination body-8 ">
        <a :class="{ invisible: currentPage === 1 }" href="#" @click.prevent="prev()">< Previous</a>
        <ul v-if="pageCount > 1">
          <li v-for="i in pageCount"><a href="#" :class="{ 'text-black': parseInt(currentPage) === i }" @click.prevent="page(i)">{{ i }}</a></li>
        </ul>
        <a :class="{ invisible: currentPage >= pageCount }" href="#" @click.prevent="next()">Next ></a>
      </div>
    </div>
  </div>
</template>

<script>
  import { isDefined } from '@/common/utils/utils';
  import SearchService from '@/common/services/search.service';
  import { PENDING } from '@/store/actions/app.actions';
  import PlayerProfileLink from '@/views/Student/PlayerProfileLink';
  import { mapGetters } from 'vuex';

  export default {
    name: 'SearchResults',

    data: function () {
      return {
        results: [],
        term: '',
        itemsPerPage: 12,
        currentPage: 1,
        total: 0,
        query: ''
      }
    },

    components: {
      PlayerProfileLink
    },

    computed: {
      pageCount: function () {
        return Math.ceil(this.total / this.itemsPerPage)
      },
      ...mapGetters(['appPending']),
    },

    beforeRouteEnter (to, from, next) {
      if (!to.query) {
        return next({name: 'student'});
      } else {
        if (!isDefined(to.query.s) || !to.query.s.length) {
          return next({name: 'student'});
        }

        if (isDefined(to.query.page) && to.query.page < 1) {
          return next({name: 'searchResults', query: {s: to.query.s, page: 1}});
        }

        return next();
      }
    },

    created () {
      this.query = isDefined(this.$route.query.s) ? this.$route.query.s : '';
      this.search();
    },

    watch: {
      '$route': 'search'
    },

    methods: {
      next: function() {
        this.currentPage = (parseInt(this.currentPage) + 1);
        this.goToPage();
      },

      prev: function() {
        if (this.currentPage <= 1) {
          return false;
        }

        this.currentPage = (parseInt(this.currentPage) - 1);
        this.goToPage();
      },

      page: function(pageNumber) {
        if (pageNumber === this.currentPage) {
          return false;
        }

        this.currentPage = pageNumber;
        this.goToPage();
      },

      goToPage: function() {
        const query = {
          s: this.query,
          page: this.currentPage
        };

        this.$router.push({name: 'searchResults', query: query});
      },

      search: function () {
        const query = this.$route.query;
        this.query = query.s;

        if (isDefined(query.page)) {
          this.currentPage = parseInt(query.page);
        }

        if (isDefined(query)) {
          this.$store.dispatch(PENDING, true);

          return SearchService.article(query.s, this.currentPage)
            .then(results => {
              this.results = results.results;
              this.total = results.total;
            })
            .finally(() => {
              this.$store.dispatch(PENDING, false);
            })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    padding-top: 236px;

    @media (min-width: config('screens.lg')) {
      padding-top: calc(config('staticHeight.header') + config('staticHeight.categoryCarousel') + config('staticHeight.breadcrumbs'));
    }
  }

  p {
    font-size: 32px;
    @apply my-10 px-3;
  }

  .pagination {
    @apply flex items-center justify-between mt-10 w-full px-3;

    a {
      @apply text-secondary;

      &:hover {
        @apply text-primary;
      }
    }

    ul {
      @apply list-reset flex;

      li {
        @apply mx-1;
      }
    }
  }
</style>
